import getPhotoUrlFromId from '@alltrails/core/utils/getPhotoUrlFromId';

// returns an array of photos that can be processed by the lightbox
function urlReformatPhotos(photos): { id: number; imgUrl: string }[] {
  return photos.map(photo => {
    const { id } = photo;

    const url = getPhotoUrlFromId({ id: photo.id, size: '2048x2048' });

    return { id, imgUrl: url };
  });
}

export default urlReformatPhotos;
